/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoicePrices
 */
export interface InvoicePrices {
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    grossAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    undiscountedNetAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    vatNormalPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    vatReducedPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    vatAmountOfDiscountedNetShareHavingNormalVat: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    vatAmountOfDiscountedNetShareHavingReducedVat: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    discountedNetShareHavingNormalVat: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    discountedNetShareHavingReducedVat: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    cashDiscountedGrossAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    customerDiscountPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    customerDiscountAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    discountedNetAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    cashDiscountPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    freightSurchargeOfPositions: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePrices
     */
    shippingCost: number;
}

/**
 * Check if a given object implements the InvoicePrices interface.
 */
export function instanceOfInvoicePrices(value: object): value is InvoicePrices {
    if (!('grossAmount' in value) || value['grossAmount'] === undefined) return false;
    if (!('undiscountedNetAmount' in value) || value['undiscountedNetAmount'] === undefined) return false;
    if (!('vatNormalPercentage' in value) || value['vatNormalPercentage'] === undefined) return false;
    if (!('vatReducedPercentage' in value) || value['vatReducedPercentage'] === undefined) return false;
    if (!('vatAmountOfDiscountedNetShareHavingNormalVat' in value) || value['vatAmountOfDiscountedNetShareHavingNormalVat'] === undefined) return false;
    if (!('vatAmountOfDiscountedNetShareHavingReducedVat' in value) || value['vatAmountOfDiscountedNetShareHavingReducedVat'] === undefined) return false;
    if (!('discountedNetShareHavingNormalVat' in value) || value['discountedNetShareHavingNormalVat'] === undefined) return false;
    if (!('discountedNetShareHavingReducedVat' in value) || value['discountedNetShareHavingReducedVat'] === undefined) return false;
    if (!('cashDiscountedGrossAmount' in value) || value['cashDiscountedGrossAmount'] === undefined) return false;
    if (!('customerDiscountPercentage' in value) || value['customerDiscountPercentage'] === undefined) return false;
    if (!('customerDiscountAmount' in value) || value['customerDiscountAmount'] === undefined) return false;
    if (!('discountedNetAmount' in value) || value['discountedNetAmount'] === undefined) return false;
    if (!('cashDiscountPercentage' in value) || value['cashDiscountPercentage'] === undefined) return false;
    if (!('freightSurchargeOfPositions' in value) || value['freightSurchargeOfPositions'] === undefined) return false;
    if (!('shippingCost' in value) || value['shippingCost'] === undefined) return false;
    return true;
}

export function InvoicePricesFromJSON(json: any): InvoicePrices {
    return InvoicePricesFromJSONTyped(json, false);
}

export function InvoicePricesFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicePrices {
    if (json == null) {
        return json;
    }
    return {
        
        'grossAmount': json['grossAmount'],
        'undiscountedNetAmount': json['undiscountedNetAmount'],
        'vatNormalPercentage': json['vatNormalPercentage'],
        'vatReducedPercentage': json['vatReducedPercentage'],
        'vatAmountOfDiscountedNetShareHavingNormalVat': json['vatAmountOfDiscountedNetShareHavingNormalVat'],
        'vatAmountOfDiscountedNetShareHavingReducedVat': json['vatAmountOfDiscountedNetShareHavingReducedVat'],
        'discountedNetShareHavingNormalVat': json['discountedNetShareHavingNormalVat'],
        'discountedNetShareHavingReducedVat': json['discountedNetShareHavingReducedVat'],
        'cashDiscountedGrossAmount': json['cashDiscountedGrossAmount'],
        'customerDiscountPercentage': json['customerDiscountPercentage'],
        'customerDiscountAmount': json['customerDiscountAmount'],
        'discountedNetAmount': json['discountedNetAmount'],
        'cashDiscountPercentage': json['cashDiscountPercentage'],
        'freightSurchargeOfPositions': json['freightSurchargeOfPositions'],
        'shippingCost': json['shippingCost'],
    };
}

export function InvoicePricesToJSON(json: any): InvoicePrices {
    return InvoicePricesToJSONTyped(json, false);
}

export function InvoicePricesToJSONTyped(value?: InvoicePrices | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'grossAmount': value['grossAmount'],
        'undiscountedNetAmount': value['undiscountedNetAmount'],
        'vatNormalPercentage': value['vatNormalPercentage'],
        'vatReducedPercentage': value['vatReducedPercentage'],
        'vatAmountOfDiscountedNetShareHavingNormalVat': value['vatAmountOfDiscountedNetShareHavingNormalVat'],
        'vatAmountOfDiscountedNetShareHavingReducedVat': value['vatAmountOfDiscountedNetShareHavingReducedVat'],
        'discountedNetShareHavingNormalVat': value['discountedNetShareHavingNormalVat'],
        'discountedNetShareHavingReducedVat': value['discountedNetShareHavingReducedVat'],
        'cashDiscountedGrossAmount': value['cashDiscountedGrossAmount'],
        'customerDiscountPercentage': value['customerDiscountPercentage'],
        'customerDiscountAmount': value['customerDiscountAmount'],
        'discountedNetAmount': value['discountedNetAmount'],
        'cashDiscountPercentage': value['cashDiscountPercentage'],
        'freightSurchargeOfPositions': value['freightSurchargeOfPositions'],
        'shippingCost': value['shippingCost'],
    };
}

